<template>
  <div class="log">
    <list-block>
      <div class="log-desc">
        <el-descriptions title="基本信息" size="medium">
          <el-descriptions-item label="规则名称">
            {{ details.name }}
          </el-descriptions-item>
          <el-descriptions-item label="规则类型">
            {{ currentatterLabel(details.type, TYPE_LIST) }}
          </el-descriptions-item>
          <el-descriptions-item label="规则机制">
            <span v-if="details.type==='FIXED_TIME'">
              {{ details.startTime +' - '+ details.endTime }}
            </span>
            <span v-else-if="details.type==='FIXED_FREQUENCY'">
              {{ details.executeNum }}次
            </span>
            <span v-else>
              -
            </span>
          </el-descriptions-item>
          <el-descriptions-item label="描述">
            {{ details.description }}
          </el-descriptions-item>
        </el-descriptions>
        <div class="line" />
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="卡控日志" name="first">
            <div>
              <LogListFilter
                :form="form"
                @search="handleSearch"
                @back="$router.push('/userCenter/popRuleManagement')"
                @export="exportLog()"
              />
              <el-descriptions
                style="margin-top: 20px;"
                title="卡控日志"
                size="small"
                :colon="false"
              >
                <el-descriptions-item label="">
                  <span class="log-tips"><i class="el-icon-info" />  管控任务{{ statisticData.totalTaskNum }}人次，执行人次{{ statisticData.executeTaskNum }}，未执行人次{{ statisticData.notExecuteTaskNum }}，管控执行率{{ statisticData.executeTaskRateStr }}</span>
                </el-descriptions-item>
              </el-descriptions>
              <ProTable
                :data="list"
                :columns="LOG_TABLE_COLUMN"
                :pagination.sync="pagination"
                :loading="loading"
              >
                <template #status="{row}">
                  <div v-if="row.status==='EXECUTE_SUCCESS'" class="success">
                    <span />通过
                  </div>
                  <div v-else-if="row.status==='EXECUTE_FAIL'" class="fail">
                    <span />
                    不通过
                  </div>
                  <div v-else class="none">
                    <span />
                    未操作
                  </div>
                </template>
                <template #taskType="{row}">
                  <div>{{ currentatterLabel(row.taskType, TASK_LIST) }}</div>
                </template>
              </ProTable>
            </div>
          </el-tab-pane>
          <el-tab-pane label="操作日志" name="second">
            <LogPersonFilter
              :form="formOperator"
              @search="handleSearch"
              @back="$router.push('/userCenter/popRuleManagement')"
              @export="exportLog()"
            />
            <!--  <el-descriptions
              style="margin-top: 20px;"
              title="操作日志"
              size="small"
              :colon="false"
            >
            <el-descriptions-item label="">
                <span class="log-tips"><i class="el-icon-info" />  管控任务{{ statisticData.totalTaskNum }}人次，执行人次{{ statisticData.executeTaskNum }}，未执行人次{{ statisticData.notExecuteTaskNum }}，管控执行率{{ statisticData.executeTaskRateStr }}</span>
              </el-descriptions-item>
            </el-descriptions> -->
            <ProTable
              :data="listOperator"
              :columns="LOG_PERSON_TABLE_COLUMN"
              :pagination.sync="paginationOperator"
              :loading="loadingOperator"
            />
          </el-tab-pane>
        </el-tabs>
      </div>
    </list-block>
  </div>
</template>
<script>
import ListBlock from '@/components/ListBlock/index.vue';
import {
  popRuleManagementPage, fetchLogDataPage, download, fetchLogStatisticData, fetchOperatorTaskLog,
} from '@/api/userControl';
import { searchFormFilter } from '@/utils';
import ProTable from '@/components/ProTable/index.vue';
import {
  LOG_TABLE_COLUMN, TASK_LIST, TYPE_LIST, LOG_PERSON_TABLE_COLUMN,
} from './constant';
import LogListFilter from './components/LogListFilter.vue';
import LogPersonFilter from './components/LogPersonFilter.vue';

export default {
  name: 'Log',
  components: {
    ListBlock,
    ProTable,
    LogListFilter,
    LogPersonFilter,
  },
  data() {
    return {
      id: null,
      pagination: {
        total: 0,
        pageSize: 10,
        currentPage: 1,
      },
      paginationOperator: {
        total: 0,
        pageSize: 10,
        currentPage: 1,
      },
      loading: false,
      loadingOperator: false,
      details: {},
      list: [],
      listOperator: [],
      statisticData: {
        totalPersonNum: '0',
        executePersonNum: '0',
        notExecutePersonNum: '0',
        notExecuteNum: '0',
        executeRate: '0',
        executeRateStr: '0%',
        totalTaskNum: '0',
        executeTaskNum: '0',
        notExecuteTaskNum: '0',
        executeTaskRate: '0',
        executeTaskRateStr: '0%',
      },
      LOG_TABLE_COLUMN,
      LOG_PERSON_TABLE_COLUMN,
      TASK_LIST,
      TYPE_LIST,
      form: {
        unifyNameLike: '',
        mobile: '',
        dateRange: [],
        companyIds: [],
        status: '',
      },
      formOperator: {
        dateRange: [],
      },
      activeName: 'first',
    };
  },
  watch: {
    pagination() {
      this.fetchData();
    },
    paginationOperator() {
      this.fetchOperatorTaskData();
    },
  },
  created() {
    this.id = this.$route.query.id;
    if (!this.id) {
      this.$router.push('/userCenter/popRuleManagement');
    }
    this.fetchDetailsData();
    this.fetchData();
    this.fetchStatisticData();
  },
  methods: {
    async exportLog() {
      let data = {};
      if (this.activeName === 'first') {
        const url = '/bfs-user/control/log/export';
        const name = 'export';
        const [executeDateGe, executeDateLe] = (this.form.dateRange && this.form.dateRange.length) ? this.form.dateRange : ['', ''];
        data = {
          ruleId: this.id,
          ...this.form,
          executeDateGe,
          executeDateLe,
        };
        const dataTemp = searchFormFilter(data);
        download(name, url, dataTemp);
      }
    },
    currentatterLabel(val, list) {
      if (!val) return val;
      const [temp] = list.filter((item) => item.value === val);
      if (temp) return temp.label;
      if (val === 'IMMEDIATE_EXECUTION') return '立即执行';
      if (val === 'ONE_TIME') return '一次';
      return temp ? temp.label : val;
    },
    async fetchData() {
      this.loading = true;
      try {
        const [executeDateGe, executeDateLe] = (this.form.dateRange && this.form.dateRange.length) ? this.form.dateRange : ['', ''];
        const data = {
          ruleId: this.id, ...this.form, executeDateGe, executeDateLe,
        };
        const params = {
          page: this.pagination.currentPage,
          size: this.pagination.pageSize,
        };
        const dataTemp = searchFormFilter(data);
        const resp = await fetchLogDataPage(dataTemp, params);
        this.pagination.total = resp.total;
        this.list = resp.records;
      } finally {
        this.loading = false;
      }
    },
    async fetchOperatorTaskData() {
      this.loadingOperator = true;
      try {
        const [startTime, endTime] = (this.formOperator.dateRange && this.formOperator.dateRange.length) ? this.formOperator.dateRange : ['', ''];
        const createTimeGe = startTime ? `${startTime} 00:00:00` : '';
        const createTimeLe = endTime ? `${endTime} 23:59:59` : '';
        const data = {
          ruleId: this.id, ...this.formOperator, createTimeGe, createTimeLe,
        };
        const params = {
          page: this.paginationOperator.currentPage,
          size: this.paginationOperator.pageSize,
        };
        const dataTemp = searchFormFilter(data);
        const resp = await fetchOperatorTaskLog(dataTemp, params);
        this.paginationOperator.total = resp.total;
        this.listOperator = resp.records;
      } finally {
        this.loadingOperator = false;
      }
    },
    async fetchStatisticData() {
      const data = { ruleId: this.id };
      const params = {};
      const resp = await fetchLogStatisticData(data, params);
      if (resp) {
        this.statisticData = resp;
      }
    },
    async fetchDetailsData() {
      const data = { id: this.id };
      const params = {
        page: 1,
        size: 10,
      };
      const resp = await popRuleManagementPage(data, params);
      this.details = resp.records?.[0];
    },
    handleSearch() {
      this.pagination.currentPage = 1;
      if (this.activeName === 'first') {
        this.fetchData();
      } else {
        this.fetchOperatorTaskData();
      }
    },
    handleClick() {
      this.form.dateRange = null;
      if (this.activeName === 'first') {
        this.fetchData();
      } else {
        this.fetchOperatorTaskData();
      }
    },
  },
};
</script>
<style scoped lang="scss">
.log{
    .log-desc{
        overflow: hidden;
        .el-button{
            float: right;
            position: relative;
            bottom: 20px;
        }
       .el-descriptions{
        :deep(.el-descriptions__title){
            border-left: 3px solid #1e3cbb;
            line-height: 13px;
            padding-left: 5px;
            font-size: 14px;
            color: #1e3cbb;
        }
       }
       .line{
            margin: 10px 0 20px 0px;
            border-bottom: 1px solid #eee;
        }
        .log-tips{
            color: #1890ff;
            font-weight: 600;
        }
    }
    .success span, .fail span, .none span{
        display: inline-block;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #656262
    }
    .success{
        color: #06B880;
        span{
            background-color: #06B880;
        }
    }
    .fail{
        color: #F2001D;
        span{
            background-color: #F2001D;
        }
    }
}
</style>
